import { TQuotesItem } from '../Quotes.types';

export const isQuotesDataValid = (quotes: TQuotesItem[]): boolean =>
  Array.isArray(quotes) &&
  quotes.length > 0 &&
  quotes.every((quote) => quote.author && quote.quote && quote._uid);
